import React from 'react';

interface WineGlassIconProps {
  className?: string;
}

/** ワインが入ったグラス（揺らしアニメ用・底を支点に） */
const WineGlassIcon: React.FC<WineGlassIconProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 96"
    className={className}
    aria-label="Wine glass"
    role="img"
    fill="none"
  >
    {/* ボウル外枠 */}
    <path
      d="M14 8h36c0 10-2 20-8 28-4 5-8 9-10 16h0c-2-7-6-11-10-16C16 28 14 18 14 8Z"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinejoin="round"
      fill="currentColor"
      fillOpacity="0.08"
    />
    {/* ワイン液面 */}
    <path
      d="M18 28c1.5 8 4.5 14 8 19 2.5 3.5 5 6 6 10 1-4 3.5-6.5 6-10 3.5-5 6.5-11 8-19H18Z"
      fill="currentColor"
      fillOpacity="0.85"
    />
    {/* 液面ハイライト */}
    <ellipse cx="32" cy="28" rx="14" ry="2.2" fill="currentColor" fillOpacity="0.35" />
    {/* ステム */}
    <path d="M32 52v28" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    {/* フット */}
    <path d="M20 84h24" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M24 88h16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.7" />
  </svg>
);

export default WineGlassIcon;
